import axios from "../../lib/axiosInstance";

export const fetchWorkforce = async (payload = {}) => {
  const queryParams = new URLSearchParams();

  if (payload.page) queryParams.append("page", payload.page);
  if (payload.limit) queryParams.append("limit", payload.limit);

  if (payload.search?.trim()) queryParams.append("search", payload.search.trim());

  if (payload.country) queryParams.append("country", payload.country);
  if (payload.city) queryParams.append("city", payload.city);
  if (payload.fullName?.trim()) queryParams.append("fullName", payload.fullName.trim());
  if (payload.talentPool) queryParams.append("talentPool", payload.talentPool);
  if (payload.jobsCompleted || payload.jobsCompleted === 0) queryParams.append("jobsCompleted", payload.jobsCompleted);
  if (payload.workedWith) queryParams.append("workedWith", payload.workedWith === 'Yes' ? true : false);
  if (payload.backgroundCheck) queryParams.append("backgroundCheck", payload.backgroundCheck === 'Yes' ? true : false);
  if (payload.certifications) queryParams.append("certifications", payload.certifications);
  if (payload.equipment) queryParams.append("equipment", payload.equipment);
  if (payload.skillSet) queryParams.append("skillSet", payload.skillSet);
  if (payload.freelanceCompanyId)
    queryParams.append("freelanceCompanyId", payload.freelanceCompanyId);

  const url = `workforce${queryParams.toString() ? `?${queryParams.toString()}` : ""}`;

  const response = await axios.get(url);
  return response.data;
};


export const fetchEngineerMapLocations = async () => {
  const response = await axios.get("workforce/map");
  return response.data;
};

export const fetchEngineerMapImage = async () => {
  const response = await axios.get("workforce/map/image", { responseType: "blob" });
  return URL.createObjectURL(response.data);
};

export const fetchWorkforceByTalentPool = async (payload = {}) => {
  const queryParams = new URLSearchParams();

  if (payload.page) queryParams.append("page", payload.page);
  if (payload.limit) queryParams.append("limit", payload.limit);

  if (payload.search?.trim()) queryParams.append("search", payload.search.trim());

  if (payload.fullName?.trim()) queryParams.append("fullName", payload.fullName.trim());
  if (payload.country) queryParams.append("country", payload.country);
  if (payload.city) queryParams.append("city", payload.city);
  if (payload.talentPool) queryParams.append("talentPool", payload.talentPool);
  if (payload.jobsCompleted || payload.jobsCompleted === 0)
    queryParams.append("jobsCompleted", payload.jobsCompleted);
  if (payload.workedWith)
    queryParams.append("workedWith", payload.workedWith === "Yes" ? true : false);
  if (payload.backgroundCheck)
    queryParams.append("backgroundCheck", payload.backgroundCheck === "Yes" ? true : false);
  if (payload.certifications) queryParams.append("certifications", payload.certifications);
  if (payload.equipment) queryParams.append("equipment", payload.equipment);
  if (payload.skillSet) queryParams.append("skillSet", payload.skillSet);

  const url = `workforce/${payload.id}${queryParams.toString() ? `?${queryParams.toString()}` : ""}`;

  const response = await axios.get(url);
  return response.data;
};

